export function dedupe<T extends object>(arr: T[], key: keyof T | ((item: T) => unknown)) {
	const getKey = typeof key === 'function' ? key : (item: T) => item[key];
	const keys = new Set<unknown>();
	return arr.filter((item) => !keys.has(getKey(item)) && keys.add(getKey(item)));
}

export function dedupePrimitive<T extends string | number>(arr: T[]) {
	return [...new Set(arr)];
}
